import CMSection from '@src/components/Atoms/CMSection';
import Image from 'next/image';
import styled from 'styled-components';
import ArrowSvg from '@src/assets/imgs/sponser/arrowLeft.svg';
import { devices } from '@src/styles/theme';

const Five = () => {
  const onBreadNews = () => {
    window.open(
      'https://www.onews.tv/news/articleView.html?idxno=186423',
      '_blank'
    );
  };

  const onPpleNightNews = () => {
    window.open(
      'http://www.m-i.kr/news/articleView.html?idxno=1043766',
      '_blank'
    );
  };
  return (
    <CMSection backgroundColor="#FFEDE8">
      <Wrap>
        <Flex>
          <Title>
            선한영향력을 위한
            <br /> <span>피플의 여정</span>
          </Title>
          <PcContent>
            헌혈자를 위한 헌혈의 밤 행사, 제빵 봉사 등 오프라인 행사를 열고
            <br />
            대학생 서포터즈 운영, 헌혈자 이벤트 진행을 통해
            <br />
            헌혈인식 개선과 헌혈자 증가를 위해 노력 하고 있습니다.
          </PcContent>
          <MbContent>
            헌혈자를 위한 헌혈의 밤 행사, 제빵 봉사 등 오프라인 행사를 열고
            대학생 서포터즈 운영, 헌혈자 이벤트 진행을 통해 헌혈 인식 개선과
            헌혈자 증가를 위해 노력합니다.
          </MbContent>
        </Flex>
        <NewsFlex>
          <ImageWrap>
            <NewsImage
              onClick={onPpleNightNews}
              src={'/imgs/sponser/night.svg'}
              width={590}
              height={580}
              alt={'pple-news'}
            />
            <NewsMbImage
              onClick={onBreadNews}
              src={'/imgs/sponser/night_mb.svg'}
              width={590}
              height={580}
              alt={'pple-news'}
            />
            <NewsTextWrap>
              <NewsText>
                4000명을 살린 헌혈 영웅들,
                <br /> ‘헌혈의 밤’ 행사로 빛난 열정
              </NewsText>
              <ArrowIcon />
            </NewsTextWrap>
          </ImageWrap>
          <ImageWrap>
            <NewsImage
              onClick={onBreadNews}
              src={'/imgs/sponser/bread.svg'}
              width={590}
              height={580}
              alt={'pple-news'}
            />
            <NewsMbImage
              onClick={onBreadNews}
              src={'/imgs/sponser/bread_mb.svg'}
              width={590}
              height={580}
              alt={'pple-news'}
            />
            <NewsTextWrap>
              <NewsText>헌혈 플랫폼 피플, 제빵 봉사·기부</NewsText>
              <ArrowIcon />
            </NewsTextWrap>
          </ImageWrap>
        </NewsFlex>
      </Wrap>
    </CMSection>
  );
};

const Wrap = styled.div`
  padding: 110px 0;
  max-width: 1200px;
  margin: 0 auto;

  @media ${devices.tablet} {
    padding: 50px 24px;
  }
`;

const Flex = styled.div`
  display: flex;
  justify-content: space-between;

  @media ${devices.tablet} {
    display: block;
  }
`;

const Title = styled.div`
  color: ${({ theme }) => theme.commonColor.black};
  font-family: 'NOTO';
  font-size: 47px;
  font-style: normal;
  font-weight: 500;
  line-height: 65px; /* 138.298% */
  letter-spacing: -1.41px;
  > span {
    color: ${({ theme }) => theme.commonColor.pink005};
  }

  @media ${devices.tablet} {
    font-size: 24px;
    line-height: 36px;
    letter-spacing: -0.72px;
  }
`;

const PcContent = styled.div`
  color: ${({ theme }) => theme.commonColor.black};
  font-family: 'Var';
  font-size: 26px;
  font-style: normal;
  font-weight: 500;
  line-height: 40px; /* 153.846% */
  display: block;
  @media ${devices.tablet} {
    display: none;
  }
`;

const MbContent = styled.div`
  display: none;
  @media ${devices.tablet} {
    display: block;
    color: ${({ theme }) => theme.commonColor.black};
    font-family: 'Var';
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px; /* 150% */
    margin-top: 30px;
  }
`;

const NewsFlex = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 60px;

  @media ${devices.tablet} {
    display: block;
    margin-top: 30px;
  }
`;

const ImageWrap = styled.div`
  cursor: pointer;
  position: relative;
  &:hover {
    > div {
      opacity: 1;
    }
  }
`;

const NewsImage = styled(Image)`
  cursor: pointer;
  border-radius: 30px;
  display: block;
  @media ${devices.tablet} {
    display: none;
  }
`;

const NewsMbImage = styled(Image)`
  cursor: pointer;
  border-radius: 10px;
  display: none;
  @media ${devices.tablet} {
    display: block;
    width: 100%;
    height: 100%;
    margin-top: 4px;
  }
`;

const NewsTextWrap = styled.div`
  transition: 0.5s all;
  opacity: 0;
  display: flex;
  align-items: center;
  width: 100%;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.1) 80%,
    rgba(0, 0, 0, 0.1) 80%
  );
  position: absolute;
  bottom: 0px;
  height: 150px;
  border-radius: 0 0 30px 30px;

  @media ${devices.tablet} {
    height: 50px;
  }
`;

const NewsText = styled.div`
  color: ${({ theme }) => theme.commonColor.white};
  font-family: 'NOTO';
  font-size: 30px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: -0.9px;
  white-space: pre-wrap;
  padding-left: 50px;

  @media ${devices.tablet} {
    font-size: 16px;
    line-height: 24px; /* 150% */
    padding-left: 20px;
  }
`;

const ArrowIcon = styled(ArrowSvg)`
  margin-left: 20px;
  width: 37px;
  height: 38px;

  @media ${devices.tablet} {
    width: 18px;
    height: 18px;
  }
`;

export default Five;
